export default function(ctx) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }

 /* add a container for the columns styling with flexbox without affecting errors div etc. */ ;
__p += '\n<div class="' +
((__t = (ctx.ofPrefix)) == null ? '' : __t) +
'columns">\n    ';
 ctx.component.columns.forEach(function(column, index) { ;
__p += '\n    <div class="column column--span-' +
((__t = (column.size)) == null ? '' : __t) +
' ';
 if (column.sizeMobile) { ;
__p += 'column--span-mobile-' +
((__t = (column.sizeMobile)) == null ? '' : __t);
 } ;
__p += ' openforms-form-field-container" ref="' +
((__t = (ctx.columnKey)) == null ? '' : __t) +
'">\n      ' +
((__t = (ctx.columnComponents[index])) == null ? '' : __t) +
'\n    </div>\n    ';
 }) ;
__p += '\n</div>\n';
return __p
}